import { AxiosResponse } from "axios";
import { Account, AccountEdit, AccountInput } from "../models/account";
import { backend } from "../utils/axios";

const ROUTE = "/account";

interface AccountServiceEndpoints {
  getAccount: () => Promise<Account>;
  editAccount: (data: AccountEdit) => Promise<Account>;
  createAccount: (data: AccountInput) => Promise<Account>;
  getClerk: (id: string) => Promise<Account>;
  editClerk: (id: string, data: AccountEdit) => Promise<Account>;
}

export const AccountService: AccountServiceEndpoints = {
  getAccount: () =>
    backend
      .get<Account>(ROUTE)
      .then(({ data }) => data)
      .catch(),
  editAccount: (data) =>
    backend
      .put<AccountInput, AxiosResponse<Account>>(ROUTE, data)
      .then(({ data }) => data)
      .catch(),
  createAccount: (data) =>
    backend
      .post<AccountInput, AxiosResponse<Account>>(ROUTE, data)
      .then(({ data }) => data)
      .catch(),
  getClerk: (id) =>
    backend
      .get<Account>(`${ROUTE}/${id}`)
      .then(({ data }) => data)
      .catch(),
  editClerk: (id, data) =>
    backend
      .put<AccountInput, AxiosResponse<Account>>(`${ROUTE}/${id}`, data)
      .then(({ data }) => data)
      .catch(),
};
